var render, staticRenderFns
import script from "./TableClient.vue?vue&type=script&lang=js"
export * from "./TableClient.vue?vue&type=script&lang=js"
import style0 from "./TableClient.vue?vue&type=style&index=0&id=4aa5bbb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aa5bbb2",
  null
  
)

export default component.exports